import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Plus, Edit2, Trash2, Ticket } from "lucide-react";
import { Modal } from "./Brands";

const today = new Date().toISOString().slice(0, 10);
const in60 = new Date(Date.now() + 60 * 86400e3).toISOString().slice(0, 10);
const empty = { brand_id: "", title: "", description: "", image_url: "", code: "", start_date: today, end_date: in60, status: "active" };

export default function Vouchers() {
  const [items, setItems] = useState([]);
  const [brands, setBrands] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/vouchers").then((r) => setItems(r.data));
  useEffect(() => { load(); api.get("/brands").then(r => setBrands(r.data)); }, []);

  const save = async (e) => {
    e.preventDefault();
    const payload = { ...form, start_date: new Date(form.start_date).toISOString(), end_date: new Date(form.end_date).toISOString() };
    if (modal === "new") await api.post("/vouchers", payload);
    else await api.patch(`/vouchers/${modal}`, payload);
    setModal(null); load();
  };

  return (
    <Layout title="Vouchers" subtitle="Coupons"
      action={<button className="btn-dark flex items-center gap-2" onClick={() => { setForm(empty); setModal("new"); }} data-testid="add-voucher-btn"><Plus size={14} /> New voucher</button>}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((v) => (
          <div key={v.id} className="card-sharp p-6 relative overflow-hidden" data-testid={`voucher-${v.id}`}>
            <div className="absolute right-0 top-0 bottom-0 w-px border-l border-dashed border-[#E6E4E0]" style={{ right: 60 }}></div>
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="label-tiny">{v.brand_name}</div>
                <div className="text-lg font-light mt-1" style={{fontFamily:"Outfit"}}>{v.title}</div>
              </div>
              <div className="w-9 h-9 bg-[#E5DAC8] flex items-center justify-center"><Ticket size={14} className="text-[#6B5634]" /></div>
            </div>
            <p className="text-sm text-[#595959]">{v.description}</p>
            {v.code && <div className="font-mono text-[12px] mt-3 bg-[#F9F8F6] inline-block px-2 py-1 border border-[#E6E4E0]">{v.code}</div>}
            <div className="flex items-center justify-between mt-5 pt-4 border-t border-[#E6E4E0]">
              <div className="text-[11px] text-[#8C8C8C]">Until {v.end_date?.slice(0,10)}</div>
              <span className={`badge badge-${v.status}`}>{v.status}</span>
            </div>
            <div className="flex gap-2 mt-3">
              <button className="btn-outline flex-1" onClick={() => { setForm({ ...v, start_date: v.start_date?.slice(0,10), end_date: v.end_date?.slice(0,10) }); setModal(v.id); }}><Edit2 size={12} /></button>
              <button className="btn-outline" onClick={async () => { if (confirm("Delete?")) { await api.delete(`/vouchers/${v.id}`); load(); } }}><Trash2 size={12} /></button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center py-12 text-[#8C8C8C]">No vouchers yet.</div>}
      </div>

      {modal && (
        <Modal onClose={() => setModal(null)} title={modal === "new" ? "New voucher" : "Edit voucher"}>
          <form onSubmit={save} className="space-y-4">
            <div><div className="label-tiny mb-1.5">Brand</div>
              <select className="fin" required value={form.brand_id} onChange={(e) => setForm({...form, brand_id: e.target.value})} data-testid="voucher-brand">
                <option value="">— select —</option>
                {brands.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
              </select>
            </div>
            <div><div className="label-tiny mb-1.5">Title</div><input className="fin" required value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} data-testid="voucher-title" /></div>
            <div><div className="label-tiny mb-1.5">Description</div><textarea className="fin" rows="3" value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} /></div>
            <div><div className="label-tiny mb-1.5">Code (optional)</div><input className="fin" value={form.code||""} onChange={(e) => setForm({...form, code: e.target.value})} /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><div className="label-tiny mb-1.5">Start</div><input type="date" className="fin" value={form.start_date?.slice(0,10)} onChange={(e) => setForm({...form, start_date: e.target.value})} /></div>
              <div><div className="label-tiny mb-1.5">End</div><input type="date" className="fin" value={form.end_date?.slice(0,10)} onChange={(e) => setForm({...form, end_date: e.target.value})} /></div>
            </div>
            <div><div className="label-tiny mb-1.5">Status</div>
              <select className="fin" value={form.status} onChange={(e) => setForm({...form, status: e.target.value})}>
                <option value="active">Active</option><option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="flex justify-end gap-2 pt-2">
              <button type="button" className="btn-outline" onClick={() => setModal(null)}>Cancel</button>
              <button type="submit" className="btn-dark" data-testid="save-voucher-btn">Save</button>
            </div>
          </form>
        </Modal>
      )}
    </Layout>
  );
}
